import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Clarity from '@microsoft/clarity';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  host: { class: 'block min-h-dvh' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly translate = inject(TranslateService);

  readonly title = 'Veredis AI App';

  constructor() {
    this.translate.use('pt-BR');
  }

  ngOnInit(): void {
    if (environment.clarityProjectId) {
      Clarity.init(environment.clarityProjectId);
    }
  }
}
